<div class="p-6">
  @if (loading) {
    <div class="flex justify-center py-8">
      <div class="animate-spin rounded-full h-6 w-6 border-b-2 border-brand-500"></div>
    </div>
  }

  @if (error) {
    <div class="mb-4 p-3 rounded-lg bg-error-50 border border-error-200 text-sm text-error-700 dark:bg-error-500/10 dark:border-error-500/20 dark:text-error-400">
      {{ error }}
    </div>
  }

  @if (!loading) {
    <form [formGroup]="form" (ngSubmit)="guardar()" class="space-y-4">
      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Nombre <span class="text-error-500">*</span>
        </label>
        <input
          type="text"
          formControlName="name"
          placeholder="Ej: Marketing"
          class="dark:bg-dark-900 h-11 w-full rounded-lg border bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs placeholder:text-gray-400 focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 dark:placeholder:text-white/30"
          [class.border-error-500]="hasError('name')"
          [class.border-gray-300]="!hasError('name')"
        />
        @if (hasError('name')) {
          <p class="mt-1.5 text-sm text-error-500">{{ getError('name') }}</p>
        }
      </div>

      <div>
        <label class="mb-1.5 block text-sm font-medium text-gray-700 dark:text-gray-300">
          Descripción
        </label>
        <textarea
          formControlName="description"
          rows="3"
          placeholder="Campañas masivas, transaccionales, etc."
          class="dark:bg-dark-900 w-full rounded-lg border border-gray-300 bg-transparent px-4 py-2.5 text-sm text-gray-800 shadow-theme-xs focus:border-brand-300 focus:outline-hidden focus:ring-3 focus:ring-brand-500/10 dark:border-gray-700 dark:bg-gray-900 dark:text-white/90 resize-y"
        ></textarea>
        @if (hasError('description')) {
          <p class="mt-1.5 text-sm text-error-500">{{ getError('description') }}</p>
        }
      </div>

      <div class="flex items-center justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
        <app-button variant="outline" type="button" (btnClick)="cancelar()">
          Cancelar
        </app-button>
        <app-button variant="primary" type="submit" [disabled]="saving || form.invalid">
          {{ saving ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear') }}
        </app-button>
      </div>
    </form>
  }
</div>
